import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { AmountWithCurrencySplit } from "@portal/BaseComponents/MultiCurrency/AmountWithCurrencySplit";
import { SnapShotTile } from "@portal/BaseComponents/SnapShotTile/SnapShotTile";
import { TileProps } from "../type";

function PTPTile(props: TileProps) {
  const { loading, data } = props;
  return (
    <HideWrapper hide={false}>
      <SnapShotTile
        direction="row"
        size="md"
        align="center"
        justify="space-between"
        heading={{ text: "Promise to Pay", fs: "14", color: "var(--gray-8)" }}
        loading={loading}
        bottomStrip={{ color: "var(--cyan-2)" }}
        headerWidth="auto"
        count={{
          title: { value: "Invoices", fs: "12" },
          fs: "12",
          value: data?.ptp_amount.invoice_count ?? 0,
          align: "start",
          width: "auto",
        }}
        amount={
          data ? (
            <AmountWithCurrencySplit
              type="multi"
              amountWithCurrencySplit={data.ptp_amount.amount}
              style={{ fontSize: "16px", fontWeight: "var(--fs-semibold)" }}
            />
          ) : undefined
        }
      />
    </HideWrapper>
  );
}

export { PTPTile };
